module.exports = __webpack_public_path__ + "static/media/mentor_marketing.ed0bb048.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/mentor_marketing.png
// module id = 403
// module chunks = 0